const PIXEL_REGEX = /px$/;

export function updateNodeStylesForComplexText(nodes, scaling) {
  if (nodes && nodes.length > 0) {
    for (let i = 0; i < nodes.length; i++) {
      let childNodes = nodes[i].children;
      if (nodes[i].tagName === 'P' || nodes[i].tagName === 'LI') {
        let applyToNode = nodes[i];
        let elementFontSize;
        if (!applyToNode.hasAttribute('data-fontsize')) {
          elementFontSize = applyToNode.style.getPropertyValue('--font-size')
            ? Number(applyToNode.style.getPropertyValue('--font-size').replace(PIXEL_REGEX, ''))
            : 16;
          if (elementFontSize) {
            applyToNode.setAttribute('data-fontsize', elementFontSize);
            let newFontSize = `${Number.parseFloat(
              Number.parseFloat(scaling) * elementFontSize,
            ).toFixed(1)}px`;
            applyToNode.style.setProperty('--font-size', newFontSize);
          }
        } else {
          elementFontSize = applyToNode.getAttribute('data-fontsize');
          let newFontSize = `${Number.parseFloat(
            Number.parseFloat(scaling) * Number(elementFontSize),
          ).toFixed(1)}px`;
          applyToNode.style.setProperty('--font-size', newFontSize);
        }
        for (let j = 0; j < childNodes.length; j++) {
          let applyToNode = nodes[i].children[j];
        // Apply font size change only to paragraph element
        let elementFontSize;
        if (!applyToNode.hasAttribute('data-fontsize')) {
          elementFontSize = applyToNode.style.fontSize
            ? Number(applyToNode.style.fontSize.replace(PIXEL_REGEX, ''))
            : 16;
          if (elementFontSize) {
            applyToNode.setAttribute('data-fontsize', elementFontSize);
            applyToNode.style.fontSize = `${Number.parseFloat(
              Number.parseFloat(scaling) * elementFontSize,
            ).toFixed(1)}px`;
          }
        } else {
          elementFontSize = applyToNode.getAttribute('data-fontsize');
          applyToNode.style.fontSize = `${Number.parseFloat(
            Number.parseFloat(scaling) * Number(elementFontSize),
          ).toFixed(1)}px`;
        }
        }
      } else {
        if (nodes[i].className.includes('ql-editor')) {
          nodes[i].setAttribute('data-scaling', scaling);
        }
        updateNodeStylesForComplexText(childNodes, scaling);
      }
    }
  }
}

export function setNodeFrame(target) {
  const { offsetWidth, offsetHeight } = target;
  if (target.style && target.style.width) {
    const targetWidth = target.style.width;
    if (targetWidth === '100%') {
      target.setAttribute('data-viewport', offsetWidth);
      target.setAttribute('data-viewheight', offsetHeight);
    } else {
      target.setAttribute('data-viewport', Number(targetWidth.replace(/px$/, '')));
      target.setAttribute('data-viewheight', offsetHeight);
    }
  } else if (offsetWidth && offsetHeight) {
    target.setAttribute('data-viewport', offsetWidth);
    target.setAttribute('data-viewheight', offsetHeight);
  }
}

export const setTableDataStyles = (nodes) => {
  if (nodes && nodes.length > 0) {
    for (let i = 0; i < nodes.length; i++) {
      let elementOriginalHeight, elementOriginalWidth;
      elementOriginalHeight = nodes[i].style.height
          ? Number(nodes[i].style.height.replace(PIXEL_REGEX, ''))
          : nodes[i].clientHeight;
      elementOriginalWidth = nodes[i].style.width
          ? Number(nodes[i].style.width.replace(PIXEL_REGEX, ''))
          : nodes[i].clientWidth;
      nodes[i].setAttribute('data-viewheight', elementOriginalHeight);
      nodes[i].setAttribute('data-viewport', elementOriginalWidth);
      if (nodes[i].style.paddingTop) {
        nodes[i].setAttribute('data-paddingtop', Number(nodes[i].style.paddingTop.replace(PIXEL_REGEX, '')));
      }
      if (nodes[i].style.paddingBottom) {
        nodes[i].setAttribute('data-paddingbottom', Number(nodes[i].style.paddingBottom.replace(PIXEL_REGEX, '')));
      }
      if (nodes[i].style.paddingLeft) {
        nodes[i].setAttribute('data-paddingleft', Number(nodes[i].style.paddingLeft.replace(PIXEL_REGEX, '')));
      }
      if (nodes[i].style.paddingRight) {
        nodes[i].setAttribute('data-paddingright', Number(nodes[i].style.paddingRight.replace(PIXEL_REGEX, '')));
      }
    }
  }
}

export const appendFonts = allFonts => {
  let styles = '';
  let qlFonts = [];
  let fontVarients = [];
  for (const font of allFonts) {
    const { name, fontFiles, languageSupported } = font;
    const fontFamily = name;
    let fontObj = {
      name: name,
      value: fontFamily,
      variants: {
        bold: false,
        italic: false,
        regular: false,
        bolditalic: false,
      },
      languageSupported
    };
    let regularDetails = undefined;
    for (const type of fontFiles) {
      let { fontType } = type;
      fontType = fontType.toLowerCase();
      fontObj.variants[fontType] = true;
      let cssText = '';
      qlFonts.push(fontFamily);
      if (fontType === 'regular') {
        cssText = generateStyleText(type, fontFamily, fontType);
        regularDetails = type;
      } else if (fontType === 'bold') {
        cssText = generateStyleText(type, fontFamily, fontType);
      } else if (fontType === 'italic') {
        cssText = generateStyleText(type, fontFamily, fontType);
      } else if (fontType === 'bolditalic') {
        cssText = generateStyleText(type, fontFamily, fontType);
      }
      styles += cssText;
    }
    if (regularDetails !== undefined) {
    if (!fontObj.variants['bold']) {
      styles += generateStyleText(regularDetails, fontFamily, 'bold');
    }
    if (!fontObj.variants['italic']) {
      styles += generateStyleText(regularDetails, fontFamily, 'italic');
    }
    if (!fontObj.variants['bolditalic']) {
      styles += generateStyleText(regularDetails, fontFamily, 'bolditalic');
    }
    }
    styles += generateQuillStyleText(fontFamily);
    fontVarients.push(fontObj);
  }
  appendCssText(styles);
  const result = {
    qlFonts: [...new Set(qlFonts)],
    fontVarients,
  };

  return result;
};

const generateStyleText = (type, fontFamily, fontType) => {
  if (type?.filePath) {
    const { fileLink, filePath } = type;
    const ext  = filePath.split('.').pop().toLowerCase();
    const format = ext === 'ttf' ? 'truetype' : ext;
    return `@font-face {
        font-family: "${fontFamily}";
        font-display: block;
        src: url("${fileLink}") format("${format}");
        ${fontType.includes('bold') ? 'font-weight: bold;' : ''}
        ${fontType.includes('italic') ? 'font-style: italic;' : ''}
      }\n
      `;
  }
  return '';
};

const generateQuillStyleText = (fontFamily) => {
  return `
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='${fontFamily}']::before,
      .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='${fontFamily}']::before {
        content: '${fontFamily}';
        font-family: '${fontFamily}';
      }\n
  `;
}
const appendCssText = styles => {
  const id = 'uploaded-fonts';
  let styleElement = document.getElementById(id);
  if (styleElement) {
    styleElement.innerHTML = styles;
  } else {
    let newStyle = document.createElement('style');
    newStyle.type = 'text/css';
    newStyle.id = id;
    newStyle.innerHTML = styles;
    document.head.appendChild(newStyle);
  }
};

export const getValuesFromTransform = (transform) => {
  const transformStyles = transform.split(' ');
  let result = {};
  transformStyles.forEach(data => {
    let key = data.split('(')[0];
    let value = data && data.match(/\((.*)\)/)[1];
    value = Number(value.replace(/[^\d.-]/g, ''));
    let pair = { [key]: value };
    result = { ...result, ...pair };
  });
  return result;
}
